<div class="modal-column">
  <div class="form-wrap">
    <form (ngSubmit)="this.recaptchaEnabled ? requestCaptcha() : submit($event);" [formGroup]="form" novalidate>
      <h4>Sign up! it’s free!</h4>
      <app-form-input formControlName="email" type="email" title="Email address">
      </app-form-input>
      <app-form-input formControlName="password" type="password" title="Choose a password">
      </app-form-input>
      <div class="randomize-username">
        <i class="fas fa-dice randomize-icon" (click)="randomize($event)"></i>
        <app-form-input formControlName="username" title="Username" data-id="signup1-username-input">
        </app-form-input>
      </div>
      <app-form-select title="Country of citizenship" formControlName="country" [options]="countries"></app-form-select>

      <app-form-checkbox formControlName="agree">
        I confirm that I'm over 18 years old and agree with
        <a href="#" (click)="$event.preventDefault(); openTC()" data-id="signup1-terms-href">
          Terms & conditions</a> and
        <a href="#" (click)="$event.preventDefault(); openPP()" data-id="signup1-policy-href">
          Privacy policy</a>
      </app-form-checkbox>

      <app-form-button type="submit" class="primary full-width" [loading]="loading"
                       [disabled]="form.invalid">
        Create account
      </app-form-button>

      <div class="resend-confirmation-code">Have an account?
        <a [routerLink]="['/', {outlets: { modal: 'login' } } ]" class="underlined-link" data-id="signup1-login-href">
          Log in
        </a>
      </div>
      <re-captcha *ngIf="recaptchaEnabled" #captchaRef="reCaptcha" (resolved)="$event && submit($event)"></re-captcha>
    </form>
  </div>

  <div class="signup-left-content bonus-thing">
    <div class="signup-value-wrap">
      <div class="reg-image"></div>
      <p class="header"><i class="fal fa-fw fa-gifts"></i> Welcome package</p>
      <p>For first 3 deposits, deposits will be doubled up to 0.3 BTC. Deposit 0.001 BTC and get 30 spins!</p>
      <p class="header"><i class="fal fa-fw fa-sync"></i> Weekly cashback</p>
      <p>If luck isn’t on your side then no need to worry — we will give you 3% cashback every week.</p>
      <p class="header"><i class="fal fa-fw fa-star"></i> VIP program</p>
      <p>Enjoy VIP only games, 10% cashback, a dedicated support manager and much more!</p>
    </div>
  </div>

  <a [routerLink]="['/', {outlets: { modal: null } } ]" class="icon close-popup" data-id="signup1-close-href">
    <i class="fal fa-times"></i>
  </a>
</div>



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/signup/1/signup-modal.template.html